module.exports = __webpack_public_path__ + "img/close.1e45bcd6.svg";